import React from 'react'
import styled from 'styled-components';
import BannerSlider from './BannerSlider/index';
import VideoBannerSlider from './VideoBannerSlider/index';
import {  theme } from 'styled-tools';

export default function Banners() {
    return (
        <BannerWrapper>
            <BannerSlider />
            <VideoBannerSlider />
        </BannerWrapper>
    )
}


const BannerWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    /* background-color: #F3F3F3; */
  background: ${theme('palette.homeBannersBg')};
  padding-top: ${theme('palette.homeBannersPadidingTop')};
    // height: 520px;
    /* border-bottom: 4px solid #fff; */
    position: relative;
`;